function redirect (url: string) {
	window.location.href = url;
}

function reload () {
	window.location.reload();
}

export default {
	redirect,
	reload
};
